export default "__VITE_ASSET__CQ$chdKl__"